<blitz-top [title]="title" [banner]="banner"></blitz-top>
<section class="page subscription-page runway">
  <div class="runway-wrapper">
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
</section>
